import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import moment from "moment";
import SideModal from "components/SideModal";
import BuyOrderForm from "./BuyOrderForm";
import WalletOverview from "./WalletOverview";
import BuyOrderOverview from "./BuyOrderOverview";
import OTP from "./OTP";
import OrderDetail from "components/SharesOrder/OrderDetail";
import OrderSuccess from "components/SharesOrder/OrderSuccess";
import { RenderAdequacyStep } from "components/AdequacyModal";
import CustomFormatNumber from "components/CustomFormatNumber";
import FormatDateWithLocale from "components/FormatDateWithLocale";
import {
    userDashboardDetailsSuccess,
    fetchPayInWalletBalanceSuccess,
    fetchBlockedWalletBalanceSuccess,
} from "store/user/account/actions";
import { selectProjectDetails, selectProjectType1to8M } from "store/project/selectors";
import { fetchTotatInvestmentAmountStart, setInvestmentStepData } from "store/user/investment/actions";
import { setAdequacyStart } from "store/user/adequacy/actions";
import { selectAdequacyStep, selectAdequacyIsAccepted } from "store/user/adequacy/selectors";
import { selectUserDashboardDetails, selectPayInWalletBalance, selectBlockedWalletBalance } from "store/user/account/selectors";
import { selectInvestmentAmountResult } from "store/user/investment/selectors";
import {
    HIDE_ADEQUACY_TILE_STATUS_STEP,
    EDIT_ORDER_STATUS,
    DELETE_ORDER_STATUS,
    SHOW_MESSAGE_ORDER_STATUS,
    KYC_STATUS_LOCAL_HIDE,
} from "constants/index";
import { PROJECT_STATUS, ORDER_STATUS } from "constants/status";
import { getProjectOffers } from "api";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import { selectCurrenKYCStatus } from "store/user/kyc/selectors";

const messages = {
    boEditSuccessSubheading: "buy_offer_edited",
    boEditSuccesslineBelowImage: "change_purchase_offer",
    purchaseFee: "purchase_fee",
    totalPurchasePrice: "total_purchase_price",
    boEditSuccessButtonText: "close_btn",
    otherDate: "other_date",
    numberOfDigitalParts: "number_of_digital_shares",
    pricePerShare: "price_per_share",
    purchasePrice: "purchase_price",
    shareShortText: "pc",
    boDetailHeading: "your_purchase_offer",
    totalRealizedBoughtAmount: "total_realized_bought_amount",
};

const BuySharesEditModal = ({
    open,
    onCloseButtonClick,
    adequacyStep,
    isAccepted,
    userDashboardDetails,
    setInvestmentStepData,
    setAdequacyStart,
    userDashboardDetailsSuccess,
    payInAmount,
    blockedAmount,
    orderData,
    onDelete,
    onUpdate,
    fetchPayInWalletBalanceSuccess,
    fetchBlockedWalletBalanceSuccess,
    projectTokenData,
    isOrderItemClicked,
    onBack,
    isSecondaryMarketUserBlocked,
    allProjects = [],
    minShareTypeWise,
    maxInvestAmount,
    fetchTotalInvestmentAmount,
    investmentAmountResult = {},
    isInvestment1to8M,
    currentKycStatus,
}) => {
    //data for the already invested amount
    const { investmentAmountData, isAmountloading, amountError } = investmentAmountResult;

    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    const [backSlideEffect, setBackSlideEffect] = useState("");

    const [step, setStep] = useState("buyOrderDetail");
    const [closeTitle, setCloseTitle] = useState("");

    const [orderStepData, setOrderStepData] = useState({});

    const [projectOffers, setProjectOffers] = useState([]);

    const singleProject = (id) => allProjects?.find((item) => item.projectID === id) || {};

    const StatusAdequacy = userDashboardDetails?.StatusAdequacy;

    const isKycCompleted = !!KYC_STATUS_LOCAL_HIDE.find((status) => status === currentKycStatus);
    const isAdequacyCompleted = !!HIDE_ADEQUACY_TILE_STATUS_STEP.find((status) => status === StatusAdequacy);

    const project = singleProject(orderData?.LinkProduct?.ProductID);

    const total = parseInt(orderData?.Shares) * parseFloat(orderData?.SharePrice);
    const purchaseFeePercent = 0;
    const purchaseFee = purchaseFeePercent > 0 ? (purchaseFeePercent * total) / 100 : 0;

    const fetchInvestmentAmount = () => {
        fetchTotalInvestmentAmount(project?.projectID);
    };

    useEffect(() => {
        if (project?.projectID && isInvestment1to8M && open) fetchInvestmentAmount();
    }, [project?.projectID, isInvestment1to8M, open]);

    useEffect(() => {
        step === "buyOrderForm" && isAdequacyCompleted && setAdequacyStart({ step: 1 });
    }, [step]);

    useEffect(() => {
        setStepAndData({
            buyOrderDetail: {
                uid: orderData?.uid,
                tag: orderData?.IsSplitAllowed === "true" ? `split-${orderData?.TypeOrder}` : orderData?.TypeOrder,
                projectImage: project?.images?.teaserImage?.path,
                projectTitle: project?.title,
                projectCity: project?.address?.city,
                expirationDate: (orderData?.CreatedDate || orderData?.ExpirationDate) && (
                    <FormatDateWithLocale
                        date={
                            orderData?.StatusOrder === ORDER_STATUS.SUCCESS
                                ? orderData.CreatedDate.split("_")[0]
                                : orderData.ExpirationDate.split("_")[0]
                        }
                    />
                ),
                shares: parseInt(orderData?.Shares),
                pricePerShare: parseFloat(orderData?.SharePrice),
                purchasePrice: parseFloat(orderData?.Amount),
                purchaseFeePercent,
                purchaseFee,
                soldShares: orderData?.IsSplitAllowed === "true" ? orderData?.SoldShares : null,
                reservedShares: orderData?.IsSplitAllowed === "true" ? orderData?.SharesInProgress : null,
                totalPurchasePrice: total + purchaseFee,
                status: orderData?.StatusOrder,
                flag: orderData?.UserCountry,
                isOrderSplit: orderData?.IsSplitAllowed === "true",
                totalShare: parseInt(orderData?.Shares),
                availableShares: orderData?.AvailableShares,
            },
            buyOrderForm: {
                flag: orderData?.UserCountry,
                buyShares: orderData?.AvailableShares,
                buyPricePerShare: orderData?.SharePrice,
                buyActiveDate: { value: "other", label: formatMessage(messages.otherDate) },
                buyActiveOtherDate:
                    orderData?.ExpirationDate && moment(new Date(orderData.ExpirationDate.split("_")[0])).format("YYYY-MM-DD"),
                splitOrder: orderData?.IsSplitAllowed === "true",
            },
        });
    }, [JSON.stringify(orderData)]);

    useEffect(() => {
        project?.projectID && project?.status?.status === PROJECT_STATUS.MARKETPLACE && fetchProjectOffers(project?.projectID);
    }, [project?.projectID]);

    // fetchProjectOffers
    const fetchProjectOffers = async (projectID) => {
        try {
            const response = await getProjectOffers(projectID);
            const projectOffers = response?.data?.data?.projectOffers?.projectOffers;
            if (projectOffers) {
                setProjectOffers(projectOffers);
            } else {
                setProjectOffers([]);
            }
        } catch (error) {
            /* error */
        }
    };

    const setStepAndData = (nextStepData) => {
        setOrderStepData({ ...orderStepData, ...nextStepData });
    };

    const reset = () => {
        setStep("buyOrderDetail");
    };

    const close = () => {
        onCloseButtonClick();
        isAdequacyCompleted && setAdequacyStart({ step: 1 });
        reset();
    };

    const BuyOrderDetail = () => {
        return (
            <OrderDetail
                backSlideEffect={backSlideEffect}
                setCloseTitle={setCloseTitle}
                isSecondaryMarketUserBlocked={isSecondaryMarketUserBlocked}
                stepHeading={formatMessage(messages.boDetailHeading)}
                orderData={{
                    tag: orderStepData.buyOrderDetail?.tag,
                    image: orderStepData.buyOrderDetail?.projectImage,
                    title: orderStepData.buyOrderDetail?.projectTitle,
                    city: orderStepData.buyOrderDetail?.projectCity,
                    shares: orderStepData.buyOrderDetail?.shares,
                    remainingShares: orderStepData.buyOrderDetail?.availableShares,
                    price: orderStepData.buyOrderDetail?.purchasePrice,
                    date: orderStepData.buyOrderDetail?.expirationDate,
                    soldShares: orderStepData.buyOrderDetail?.soldShares,
                    reservedShares: orderStepData.buyOrderDetail?.reservedShares,
                    perSharePrice: orderStepData.buyOrderDetail?.pricePerShare,
                    flag: orderStepData.buyOrderDetail?.flag,
                    isOrderSplit: orderStepData.buyOrderDetail?.isOrderSplit,
                    sliptSharePrice: orderStepData.buyOrderDetail?.sliptSharePrice,
                    totalShare: orderStepData.buyOrderDetail?.totalShare,
                    status: orderStepData.buyOrderDetail?.status,
                    uid: orderStepData.buyOrderDetail?.uid,
                    totalPurchasePrice: orderStepData.buyOrderDetail?.totalPurchasePrice,
                }}
                isRowData={SHOW_MESSAGE_ORDER_STATUS.includes(orderStepData.buyOrderDetail?.status) ? false : true}
                rowData={[
                    {
                        left: `${formatMessage(messages.numberOfDigitalParts)}`,
                        right: (
                            <>
                                <CustomFormatNumber
                                    value={orderStepData.buyOrderDetail?.shares}
                                    fixed="0"
                                    symbol={formatMessage(messages.shareShortText)}
                                />
                            </>
                        ),
                    },
                    {
                        left: `${formatMessage(messages.pricePerShare)}`,
                        right: <CustomFormatNumber value={orderStepData.buyOrderDetail?.pricePerShare} />,
                    },
                    {
                        left: `${formatMessage(messages.purchasePrice)}`,
                        right: (
                            <CustomFormatNumber
                                value={
                                    parseFloat(orderStepData.buyOrderDetail?.shares) *
                                    parseFloat(orderStepData.buyOrderDetail?.pricePerShare)
                                }
                            />
                        ),
                    },
                    {
                        left: `${formatMessage(messages.purchaseFee)} (${orderStepData.buyOrderDetail?.purchaseFeePercent}%):`,
                        right: <CustomFormatNumber value={orderStepData.buyOrderDetail?.purchaseFee} />,
                    },
                    {
                        left: `${formatMessage(messages.totalPurchasePrice)}`,
                        right: <CustomFormatNumber value={orderStepData.buyOrderDetail?.totalPurchasePrice} />,
                    },
                ]}
                totalRealizedAmount={{
                    left: `${formatMessage(messages.totalRealizedBoughtAmount)}`,
                    right: (
                        <CustomFormatNumber
                            value={
                                parseFloat(orderStepData.buyOrderDetail?.soldShares) *
                                parseFloat(orderStepData.buyOrderDetail?.pricePerShare)
                            }
                        />
                    ),
                }}
                isOrderInfoContent={SHOW_MESSAGE_ORDER_STATUS.includes(orderStepData.buyOrderDetail?.status) ? true : false}
                onEdit={
                    EDIT_ORDER_STATUS.includes(orderStepData.buyOrderDetail?.status)
                        ? () => {
                              setBackSlideEffect("step-slide-left");
                              setStep("buyOrderForm");
                          }
                        : null
                }
                onDeactivate={
                    orderStepData.buyOrderDetail?.status === ORDER_STATUS.ACTIVE
                        ? (orderID) => {
                              onUpdate({ uid: orderID, StatusOrder: ORDER_STATUS.DEACTIVATE });
                              if (isInvestment1to8M) fetchTotalInvestmentAmount(project?.projectID);
                          }
                        : null
                }
                onDelete={
                    DELETE_ORDER_STATUS.includes(orderStepData.buyOrderDetail?.status) ? (orderID) => onDelete(orderID) : null
                }
                isOrderItemClicked={isOrderItemClicked}
                onBack={onBack}
                projectStatus={project?.status?.status}
            />
        );
    };

    const renderStep = (step) => {
        switch (step) {
            case "buyOrderDetail":
                return <BuyOrderDetail />;
            case "adequacyProcess":
                return (
                    <RenderAdequacyStep
                        onAdequacyBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("buyOrderForm");
                        }}
                        onWarningNext={() => {
                            setBackSlideEffect("step-slide-left");
                            setStep("walletOverview");
                        }}
                        isAccepted={isAccepted}
                        investSum={orderStepData.adequacyProcess?.shares}
                        isWithOrder
                        step={adequacyStep}
                        kycCompleted={isKycCompleted}
                        adequacyCompleted={isAdequacyCompleted}
                        setInvestmentStepData={setInvestmentStepData}
                        setAdequacyStart={setAdequacyStart}
                        userDashboardDetailsSuccess={userDashboardDetailsSuccess}
                        open={open}
                    />
                );
            case "buyOrderForm":
                return (
                    <BuyOrderForm
                        minShareTypeWise={minShareTypeWise}
                        maxInvestAmount={maxInvestAmount}
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        payInAmount={payInAmount}
                        amountError={amountError}
                        isAmountloading={isAmountloading}
                        investmentAmountData={investmentAmountData}
                        isInvestment1to8M={isInvestment1to8M}
                        stepData={orderStepData.buyOrderForm}
                        setStepAndData={setStepAndData}
                        projectTokenData={projectTokenData}
                        projectOffers={projectOffers}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("buyOrderDetail");
                        }}
                        onForward={(values) => {
                            setBackSlideEffect("step-slide-left");

                            const total = parseInt(values.buyShares) * parseFloat(values.buyPricePerShare);
                            const purchaseFeePercent = 0;
                            const purchaseFee = purchaseFeePercent > 0 ? (purchaseFeePercent * total) / 100 : 0;
                            const expirationDate =
                                values.buyActiveDate &&
                                (values.buyActiveDate.value === "other"
                                    ? moment(new Date(values.buyActiveOtherDate)).format("YYYY-MM-DD")
                                    : values.buyActiveDate.value);
                            const additionalParams = values.isMoreThan1k
                                ? {
                                      SelfDeclarationMoreThan100000FreelyDisposable: `${values.moreThan100kFreelyDisposable}`,
                                      SelfDeclarationNotMoreThanDoubleMonthlyNetIncome: `${values.notMoreThanDoubleMonthlyIncome}`,
                                  }
                                : values.isMoreThan10k
                                ? {
                                      SelfDeclarationNotMoreThanDoubleMonthlyNetIncome: `${values.notMoreThanDoubleMonthlyIncome}`,
                                  }
                                : {};

                            setStepAndData({
                                buyOrderForm: values,
                                adequacyProcess: {
                                    shares: parseInt(values.buyShares),
                                },
                                walletOverview: {
                                    purchasePrice: total,
                                    purchaseFeePercent,
                                    purchaseFee,
                                    totalPurchasePrice: total + purchaseFee,
                                    remainingCredit: payInAmount - (total + purchaseFee),
                                },
                                buyOrderOverview: {
                                    uid: orderData?.uid,
                                    tag: values?.splitOrder ? `split-${orderData.TypeOrder}` : orderData.TypeOrder,
                                    flag: values.UserCountry,
                                    projectImage: project?.images?.teaserImage?.path,
                                    projectTitle: project?.title,
                                    projectCity: project?.address?.city,
                                    expirationDate: <FormatDateWithLocale date={expirationDate} />,
                                    shares: parseInt(values.buyShares),
                                    pricePerShare: parseFloat(values.buyPricePerShare),
                                    purchasePrice: total,
                                    purchaseFeePercent,
                                    purchaseFee,
                                    totalPurchasePrice: total + purchaseFee,
                                },
                                OTP: {
                                    ID: orderData?.uid,
                                    Shares: values.buyShares,
                                    SharePrice: values.buyPricePerShare,
                                    ExpirationDate: expirationDate,
                                    ...additionalParams,
                                },
                                orderSuccess: {
                                    flag: values.UserCountry,
                                    tag: values?.splitOrder ? `split-${orderData.TypeOrder}` : orderData.TypeOrder,
                                    projectImage: project?.images?.teaserImage?.path,
                                    projectTitle: project?.title,
                                    projectCity: project?.address?.city,
                                    expirationDate: <FormatDateWithLocale date={expirationDate} />,
                                    shares: parseInt(values.buyShares),
                                    pricePerShare: parseFloat(values.buyPricePerShare),
                                    purchasePrice: total,
                                    purchaseFeePercent,
                                    purchaseFee,
                                    totalPurchasePrice: total + purchaseFee,
                                },
                            });
                            setStep("adequacyProcess");
                        }}
                    />
                );
            case "walletOverview":
                return (
                    <WalletOverview
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        payInAmount={payInAmount}
                        stepData={orderStepData.walletOverview}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("adequacyProcess");
                        }}
                        onForward={() => {
                            setBackSlideEffect("step-slide-left");
                            setStep("buyOrderOverview");
                        }}
                    />
                );
            case "buyOrderOverview":
                return (
                    <BuyOrderOverview
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        stepData={orderStepData.buyOrderOverview}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("walletOverview");
                        }}
                        onForward={() => {
                            setBackSlideEffect("step-slide-left");
                            setStep("OTP");
                        }}
                    />
                );
            case "OTP":
                return (
                    <OTP
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        stepData={orderStepData.OTP}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("buyOrderOverview");
                        }}
                        onForward={(order) => {
                            setBackSlideEffect("step-slide-left");

                            onUpdate(order);

                            // Update payIn wallet balance
                            fetchPayInWalletBalanceSuccess({
                                Amount: parseFloat(payInAmount) - parseFloat(orderStepData.buyOrderOverview.totalPurchasePrice),
                            });

                            // Update blocked wallet balance
                            fetchBlockedWalletBalanceSuccess({
                                Amount: parseFloat(blockedAmount) + parseFloat(orderStepData.buyOrderOverview.totalPurchasePrice),
                            });

                            setStep("orderSuccess");
                        }}
                        fetchInvestmentAmount={fetchInvestmentAmount}
                    />
                );
            case "orderSuccess":
                return (
                    <OrderSuccess
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        subHeading={formatMessage(messages.boEditSuccessSubheading)}
                        lineBelowImage={formatMessage(messages.boEditSuccesslineBelowImage)}
                        // buttonClass=""
                        buttonText={formatMessage(messages.boEditSuccessButtonText)}
                        // content=""
                        orderItemData={{
                            className: "border-active-blue",
                            tag: orderStepData.orderSuccess?.tag,
                            flag: orderStepData.orderSuccess?.flag,
                            image: orderStepData.orderSuccess?.projectImage,
                            title: orderStepData.orderSuccess?.projectTitle,
                            city: orderStepData.orderSuccess?.projectCity,
                            shares: orderStepData.orderSuccess?.shares,
                            price: orderStepData.orderSuccess?.purchasePrice,
                            date: orderStepData.orderSuccess?.expirationDate,
                            pricePerShare: orderStepData.orderSuccess?.pricePerShare,
                        }}
                        rowData={[
                            {
                                left: `${formatMessage(messages.purchaseFee)} (${
                                    orderStepData.orderSuccess?.purchaseFeePercent
                                }%):`,
                                right: orderStepData.orderSuccess?.purchaseFee,
                            },
                            {
                                left: formatMessage(messages.totalPurchasePrice),
                                right: orderStepData.orderSuccess?.totalPurchasePrice,
                            },
                        ]}
                        onBackToProperty={() => close()}
                    />
                );
            default:
                return <BuyOrderDetail />;
        }
    };

    return (
        <SideModal
            className="buy-shares-edit-modal"
            containerClassName="buy-share-edit-modal-container"
            heading={closeTitle}
            open={open}
            onCloseButtonClick={() => close()}
        >
            {renderStep(step)}
        </SideModal>
    );
};

const mapStateToProps = createStructuredSelector({
    adequacyStep: selectAdequacyStep,
    isAccepted: selectAdequacyIsAccepted,
    userDashboardDetails: selectUserDashboardDetails,
    payInAmount: selectPayInWalletBalance,
    blockedAmount: selectBlockedWalletBalance,
    allProjects: selectProjectDetails,
    isInvestment1to8M: selectProjectType1to8M,
    investmentAmountResult: selectInvestmentAmountResult,
    currentKycStatus: selectCurrenKYCStatus,
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
    setAdequacyStart: (data) => dispatch(setAdequacyStart(data)),
    userDashboardDetailsSuccess: (data) => dispatch(userDashboardDetailsSuccess(data)),
    fetchPayInWalletBalanceSuccess: (value) => dispatch(fetchPayInWalletBalanceSuccess(value)),
    fetchBlockedWalletBalanceSuccess: (value) => dispatch(fetchBlockedWalletBalanceSuccess(value)),
    fetchTotalInvestmentAmount: (value) => dispatch(fetchTotatInvestmentAmountStart(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BuySharesEditModal);
